import { TripPrice } from '../../lib/types/models/trip-price/trip-price'
import { TripPriceInput } from '../../lib/types/models/trip-price/trip-price-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripPrice(data: UpdateInput<TripPriceInput> & { tripId: number }) {
  const { id, tripId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.trips.updateTripPrice.url, { id: tripId, priceId: id }))
    .patch<TripPrice, Partial<TripPriceInput>>(rest)
}
